import Cookies from 'js-cookie';
import { callAPI } from '..';
import { apiPath } from '..';
import { getCookieToken } from '..';

const getInvoiceDevice = async () => {
    try {
        const token = await getCookieToken();
        let headers = { 'token': token };

        const url = apiPath.GET_URL_INVOICE;
        const method = 'GET';
        const response = await callAPI({ method, url, headers });
        const httpCode = response.status || -1;

        if (httpCode === 200) {
            let payload = null;

            if (typeof response.data === 'string') {
                payload = JSON.parse(response.data);
            } else {
                payload = response.data;
            }

            console.log(payload);

            if (payload) {
                return payload;
            } else {
                return null;
            }
        } else if (httpCode !== -1) {
            alert(`網站遇到錯誤 - HTTP 狀態碼: httpCode`);
            return null;
        } else {
            console.error('API 未執行:', url);
            return null;
        }
    } catch (error) {
        console.error('Error :', error);
        return null;
    }
};

const callAddInvoiceDevice = async (data) => {
    try {
        const token = await getCookieToken();
        let headers = { 'Content-Type': 'application/json', 'token': token };

        const url = apiPath.GET_URL_ADDINVOICEDEVICE;
        const method = 'POST';
        const response = await callAPI({ method, url, headers, data });
        const httpCode = response.status || -1;

        if (httpCode === 200) {
            let payload = null;

            if (typeof response.data === 'string') {
                payload = JSON.parse(response.data);
            } else {
                payload = response.data;
            }

            console.log(payload);

            if (payload) {
                return payload;
            } else {
                return null;
            }
        } else if (httpCode !== -1) {
            alert(`網站遇到錯誤 - HTTP 狀態碼: httpCode`);
            return null;
        } else {
            console.error('API 未執行:', url);
            return null;
        }
    } catch (error) {
        console.error('Error :', error);
        return null;
    }
};

const callUpdateInvoiceDevice = async (data, password) => {
    try {
        const token = await getCookieToken();
        let headers = { 'Content-Type': 'application/json', 'token': token, 'password': password };

        const url = apiPath.GET_URL_UPDATEINVOICEDEVICE;
        const method = 'POST';
        const response = await callAPI({ method, url, headers, data });
        const httpCode = response.status || -1;

        if (httpCode === 200) {
            let payload = null;

            if (typeof response.data === 'string') {
                payload = JSON.parse(response.data);
            } else {
                payload = response.data;
            }

            console.log(payload);

            if (payload) {
                return payload;
            } else {
                return null;
            }
        } else if (httpCode !== -1) {
            alert(`網站遇到錯誤 - HTTP 狀態碼: httpCode`);
            return null;
        } else {
            console.error('API 未執行:', url);
            return null;
        }
    } catch (error) {
        console.error('Error :', error);
        return null;
    }
};

export { getInvoiceDevice, callAddInvoiceDevice, callUpdateInvoiceDevice };